window.changePerPageParam = function () {
  var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
  var urlParams = new URLSearchParams(document.location.search);
  var perPage = document.getElementById('rows').value;

  urlParams.set('per_page', perPage);
  urlParams.delete('page');

  window.location.href = baseUrl + '?' + urlParams.toString();
}